import { Link, TitleHtmlTag } from 'shared/types';
import { FormattedProps } from './types';
import { getLinkHref } from 'shared/helpers/uri';
import { BlockOneshopUpdatingOptionsLogin } from 'shared/api/client';

export const propsFormatter = (
  content: BlockOneshopUpdatingOptionsLogin['content']
): FormattedProps => {
  return {
    title: {
      label: content.title.label ?? '',
      htmlTag: content.title.htmlTag
        ? (content.title.htmlTag as TitleHtmlTag)
        : undefined
    },
    subtitle: content.subtitle ?? null,
    renewalNumberInputLabel: content.renewal_number_input_label,
    submitButton: {
      label: content.submit_button.label ?? '',
      link: getLinkHref(
        content.submit_button.link ? (content.submit_button.link as Link) : null
      )
    },
    previousButton: content.previous_button
      ? {
          label: content.previous_button.label ?? '',
          link: getLinkHref(
            content.previous_button.link
              ? (content.previous_button.link as Link)
              : null
          )
        }
      : null
  };
};

export default propsFormatter;
